import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

function AssignPickupBoy({ show, data, handleClose, onConfirm }) {
    const [deliveryBoyName, setDeliveryBoyName] = useState("");
    const [deliveryBoyNumber, setDeliveryBoyNumber] = useState("");
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    // Reset fields every time the modal is opened for a new order
    useEffect(() => {
        if (show) {
            setDeliveryBoyName("");
            setDeliveryBoyNumber("");
            setErrors({});
        }
    }, [show]);

    const validate = () => {
        const newErrors = {};
        if (!deliveryBoyName.trim()) {
            newErrors.name = "Delivery boy name is required";
        }
        if (!deliveryBoyNumber.trim()) {
            newErrors.number = "Delivery boy number is required";
        } else if (!/^\d{10}$/.test(deliveryBoyNumber.trim())) {
            newErrors.number = "Enter a valid 10-digit number";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setSubmitting(true);
        try {
            await onConfirm(data?.id, {
                delivery_boy_name: deliveryBoyName.trim(),
                delivery_boy_number: deliveryBoyNumber.trim(),
            });
            handleClose();
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal show={!!show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Assign Delivery Boy for Pickup</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {data?.invoice_no && (
                    <p className="mb-3">
                        <b>Order:</b> {data.invoice_no}
                    </p>
                )}

                <Form.Group className="mb-3">
                    <Form.Label>Delivery Boy Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter delivery boy name"
                        value={deliveryBoyName}
                        onChange={(e) => setDeliveryBoyName(e.target.value)}
                        isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.name}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Delivery Boy Contact Number</Form.Label>

                    <Form.Control
                        type="text"
                        placeholder="Enter delivery boy contact number"
                        value={deliveryBoyNumber}
                        maxLength={10}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setDeliveryBoyNumber(value);
                        }}
                        isInvalid={!!errors.number}
                    />

                    <Form.Control.Feedback type="invalid">
                        {errors.number}
                    </Form.Control.Feedback>
                </Form.Group>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? "Saving..." : "Confirm & Send Pickup"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AssignPickupBoy;